import React from 'react';
import * as promptsActionsConstants from './prompts-constants';

export const prompt = ({ component }: { component?: React.ReactNode } = {}) => {
  return {
    type: promptsActionsConstants.PROMPTS_ADD_COMPONENT,
    payload: {
      component,
    },
  };
};

export const clearSpecificPrompt = ({ id }: { id?: number } = {}) => {
  return {
    type: promptsActionsConstants.PROMPTS_CLEAR_SPECIFIC,
    payload: {
      id,
    },
  };
};

export const clearPrompts = () => {
  return {
    type: promptsActionsConstants.PROMPTS_CLEAR,
  };
};
